// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__16iSf","header":"Messages_header__Gfvjt"};